"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EEnvironment = void 0;
/**
 * Which environment is running
 */
var EEnvironment;
(function (EEnvironment) {
    EEnvironment["Live"] = "live";
    EEnvironment["Localhost"] = "localhost";
    EEnvironment["Dev"] = "dev";
})(EEnvironment = exports.EEnvironment || (exports.EEnvironment = {}));
//# sourceMappingURL=Environment.js.map